export default class RememberMe {
	public email: string;
	public rememberMe: boolean;
}



// WEBPACK FOOTER //
// ./Client/Scripts/models/rememberMe.model.ts